<template>
  <div v-if="isShow">
    <div class="fixed" @click="onClose"></div>
    <div class="secondary-dialog" :style="style">
      <div class="arrow-icon"></div>
      <div class="dg-body" :style="{width:device.desktop?'500px':'90vw'}">
        <div class="dg-content">
          <div ref="secondaryContent" class="secondary-content"
               v-html="html"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import eventBus from '@/plugins/eventBus';
  import handleDetailContent from '@/views/wiki/modules/detailContent';
  import { mapGetters } from 'vuex';

  export default {
    name: 'secondaryDialog',
    mixins: [],
    props: {
      type: {
        default: 1,
      }
    },
    model: {},
    components: {},
    data () {
      return {
        isShow: false,
        html: '',
        style: null,
        iconLeft: 0,
      };
    },
    computed: {
      ...mapGetters(['device'])
    },
    methods: {
      onClose () {
        this.html = '';
        this.style = null;
        this.isShow = false;
      },
      async secondaryData (params) {
        let rect = params.rect;
        let target = params.target;
        this.html = params.html;
        this.isShow = true;
        await this.$nextTick();
        this.handleDetailContent = new handleDetailContent(this.$refs.secondaryContent, this);
        await this.$nextTick();
        const cRect = this.$el.querySelector('.secondary-dialog').getBoundingClientRect();
        let sTop = document.documentElement.scrollTop || document.body.scrollTop;
        console.log(sTop, { rect }, { cRect });
        const headHeight = 54 + 90 + 40;
        const leftSpaceWidth = (window.innerWidth - 1380) / 2;
        let top = sTop + rect.top + rect.height + 10 - headHeight +'px';
        let left = (rect.left - (cRect.width / 2) + (rect.width / 2)) - leftSpaceWidth + 'px';
        if (this.type === 2) {
          top = sTop + rect.top + rect.height + 10 - 290 + 'px';
          left = (rect.left - (cRect.width / 2) + (rect.width / 2)) - ((window.innerWidth - 1380) / 2) + 'px';
        }
        this.style = {
          top: top,
          left: left,
        };
        await this.handleDetailContent.handleEleReadOnly();
        this.handleDetailContent.initTableFilter();
        this.handleDetailContent.handleImgGroup();
      }
    },
    watch: {},
    created () {
    },
    beforeMount () {
      eventBus.$on('secondaryData', this.secondaryData);
    },
    mounted () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    }
  };
</script>

<style lang="less" scoped>
@import url('./../../../assets/css/detailContent');

/deep/ .secondary-dialog {
  .el-dialog__header {
    border-bottom: 1px solid @border-basic;
  }

  .el-dialog__body {
    height: 60vh;
  }

  .split-box {
    width: 100%;
    height: 10px;
    background: #f5f5f5;
  }
}


.secondary-dialog {
  position: absolute;
  z-index: 50;
  box-shadow: 0 0 10px #ddd;
  border-radius: 10px;

  .arrow-icon {
    position: absolute;
    top: -5px;
    left: calc(50% - 7px);
    z-index: 0;
    width: 12px;
    height: 12px;
    background: #fff;
    box-shadow: 0 0 10px #ddd;
    transform: rotate(-45deg);
    border-radius: 0 3px 0 0;
  }

  .dg-body {
    position: relative;
    z-index: 1;
    background: #fff;
    border-radius: 10px;
    padding: 14px;

    .dg-content {
      height: auto;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
}

.fixed {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 49;
  left: 0;
  top: 0;
}
</style>
